import { render, staticRenderFns } from "./ProductMainAddIframe.vue?vue&type=template&id=05afd08e&"
import script from "./ProductMainAddIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductMainAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports